// A read-only catalogue of the same menu API; existing chart routes own their filters.
export const excludedIds = new Set([
  'real_undervalued_1', 'real_undervalued_2', 'real_undervalued_7',
  'real_pricestat_1', 'real_pricestat_2', 'real_pricestat_6', 'real_pricestat_7',
  'real_pricestat_9', 'real_pricestat_10',
  'real_danji_1', 'real_danji_2', 'real_danji_3', 'real_danji_4',
]);
export const excludedNames = new Set([
  '리치고AI시세(지역, 유형별)',
  '리치고AI시세(지역, 리치고 & KB)',
  '리치고AI시세(단지, 리치고 & KB)',
  '매매전세 신거래가 캔들차트(시군구)',
  '매물호가 캔들차트(시군구)',
  '역전세 지역 분석',
  '역전세 단지 분석',
  '시도별 은행 대출위험',
  '시도별 유형별 대출위험',
]);
export function flattenMenus(menus) {
  const result = new Map();
  function visit(node, category, path = [], excluded = false) {
    if (!node) return;
    const names = [...path, node.name];
    const unavailable = excluded || (category === 'realestate' && (excludedIds.has(node.id) || excludedNames.has(node.name)));
    if (node.url && [100,200,300].includes(node.authorityLevel)) {
      const group = names[1] === '유형별' ? names[2] : names[1];
      const description = (node.desc || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/\s+/g, ' ').replace(/^설명\s*:\s*/, '').trim();
      const item = { ...node, category, group: group || node.name, description, unavailable, search: [names.join(' '), description, ...(node.tags || [])].join(' ').toLowerCase() };
      if (!result.has(node.url) || (result.get(node.url).unavailable && !unavailable)) result.set(node.url, item);
    }
    (node.children || []).forEach(child => visit(child, category, names, unavailable));
  }
  Object.keys(menus).forEach(category => visit(menus[category], category));
  return [...result.values()];
}
export function readFavorites() {
  try { const values = JSON.parse(localStorage.getItem('expert.favorites.v1') || '[]'); return Array.isArray(values) ? values.filter(v => typeof v === 'string') : []; } catch (_) { return []; }
}
